module.exports = __webpack_public_path__ + "static/media/login_icon.70cb43f2.svg";